export enum TOAST_STATUS {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}

export interface Toast {
  id?: number;
  title: string;
  message: string;
  status: TOAST_STATUS;
  isDisplayed: boolean;
  dismiss: boolean;
}
